var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutodeskSymbol = function SvgAutodeskSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110.678 75.705"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m.587 75.705 67.78-42.164h35.176c1.084 0 2.078.858 2.078 2.077 0 .993-.452 1.399-.994 1.715l-33.28 19.954c-2.168 1.309-2.935 3.882-2.935 5.823l-.045 12.595h42.311V2.618c0-1.4-1.084-2.618-2.709-2.618h-40.37L0 41.983v33.722z"
  })));
};
export default SvgAutodeskSymbol;